import React from "react";
import { Label } from "reactstrap";
import classNames from "classnames";

import style from "./TitleLabel.scss";

export const TitleLabel = ({ label, className, ...otherProps }) => {
  const newClasses = classNames(className, style.cardTitle);
  return (
    <Label className={newClasses} {...otherProps}>
      {label}
    </Label>
  );
};
